import {Component, OnInit, OnDestroy} from '@angular/core';
import {LoginService} from '../login/login.service';

import {Empresa} from '../empresa/empresa';
import {Sucursal} from '../sucursal/sucursal';
import {Ubicacion} from '../ubicacion/ubicacion';

import {EmpresaService} from '../empresa/empresa.service';
import {RegAlarmaService} from '../regAlarma/regAlarma.service';
import {NodoService} from '../nodo/nodo.service';

import * as io from "socket.io-client";
import myGlobals = require('../config');
import {DateTimeZonePipe} from "../pipes/dateTimeZonePipe";


declare var $: any;


var Highcharts = require('highcharts');

// Load module after Highcharts is loaded
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/solid-gauge')(Highcharts);

let ChartGlobal = [];


@Component({
    selector: 'home',
    template: require('../../app/home/home.component.html'),
    styles: [require('../../app/home/home.component.css')],
    pipes: [DateTimeZonePipe]
})

export class HomeComponent implements OnInit, OnDestroy {
    usuario = '';
    sucursales: Sucursal[];
    socket: any;
    socketSensor: any;
    usuarioConectado: any;

    constructor(private regAlarmaService: RegAlarmaService,
                private nodoService: NodoService,
                private loginService: LoginService) {
    }

    ngOnDestroy() {
        this.socket.disconnect();
        this.socketSensor.disconnect();
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        this.usuarioConectado = this.loginService.getDecodeToken();

        //Desactivar auto slide
        $("#myCarousel").carousel({
            interval: false
        });

        //Conectar al socket con configuración específica
        this.socket = io.connect(myGlobals.default.URL_MQTT_ALARMAS, { 
            path: myGlobals.default.PATH_MQTT_ALARMAS,
            transports: ['websocket', 'polling'], // Priorizar websocket
            upgrade: true,
            rememberUpgrade: true
        });
        
        this.socketSensor = io.connect(myGlobals.default.URL_MQTT, { 
            path: myGlobals.default.PATH_MQTT,
            transports: ['websocket', 'polling'], // Priorizar websocket
            upgrade: true,
            rememberUpgrade: true
        });

        // Debug de conexiones
        this.socket.on('connect', () => {
            console.log('Socket alarmas conectado via:', this.socket.io.engine.transport.name);
            this.socket.io.engine.on('upgrade', () => {
                console.log('Socket alarmas actualizado a:', this.socket.io.engine.transport.name);
            });
        });

        this.socketSensor.on('connect', () => {
            console.log('Socket sensor conectado via:', this.socketSensor.io.engine.transport.name);
            this.socketSensor.io.engine.on('upgrade', () => {
                console.log('Socket sensor actualizado a:', this.socketSensor.io.engine.transport.name);
            });
        });

        this.inicializarSocketAlarma();

        //Cargar arbol
        this.recargar();
    }

    private recargar() {
        //Arbol de sucursales->ubicaciones->nodos->sensores segun usuario logueado
        this.nodoService.getNodosInfoBasica().subscribe(
            sucursalesConTodo => {

                this.sucursales = sucursalesConTodo;
                for (let s = 0; s < this.sucursales.length; s++) {
                    let sucursal = this.sucursales[s];
                    if (!sucursal.estado) {
                        this.sucursales.splice(this.sucursales.indexOf(sucursal), 1);
                        s--;
                        continue;
                    }
                    //sucursal.alarmaActiva = false;
                    for (let u = 0; u < sucursal.ubicaciones.length; u++) {
                        let ubicacion = sucursal.ubicaciones[u];
                        if (!ubicacion.estado) {
                            sucursal.ubicaciones.splice(sucursal.ubicaciones.indexOf(ubicacion), 1);
                            u--;
                            continue;
                        }
                        //ubicacion.alarmaActiva=false;
                        //Busco alarmas por nodo
                        for (let n = 0; n < ubicacion.nodos.length; n++) {
                            let nodo = ubicacion.nodos[n];
                            if (!nodo.estado) {
                                ubicacion.nodos.splice(ubicacion.nodos.indexOf(nodo), 1);
                                n--;
                                continue;
                            }

                            if (nodo.regAlarmas.length > 0) {
                                nodo.alarmaActiva = true;
                                ubicacion.alarmaActiva = true;
                                sucursal.alarmaActiva = true;

                                ubicacion.color = "Rojo";
                                nodo.color = "Rojo";
                                sucursal.color = "Rojo";
                            }
                            else
                                nodo.alarmaActiva = false;

                            for (let s = 0; s < nodo.sensores_id.length; s++) {
                                let sensor = nodo.sensores_id[s];
                                //console.log("SENSOR " + sensor.etiqueta + " NODO " + nodo.etiqueta);
                                sensor.alarmaActiva = false;
                                //nodo.alarmaActiva = false;
                                //ubicacion.alarmaActiva = false;
                                //sucursal.alarmaActiva = false;
                                //Busco alarmas por sensor
                                if ((!sensor.estado) || (sensor.posicionString == 9 && this.usuarioConectado.rol != "Administrador" && this.usuarioConectado.rol != "Tecnico")) {
                                    nodo.sensores_id.splice(nodo.sensores_id.indexOf(sensor), 1);
                                    s--;
                                    continue;
                                }
                                if (sensor.regAlarmas.length > 0) {
                                    let color = "Amarillo";
                                    sensor.regAlarmas.map((regAlarmaSensor) => {
                                        if (regAlarmaSensor.color == "Rojo" || (regAlarmaSensor.tipoEspecial == "BATERIABAJA" && (regAlarmaSensor.color == "Rojo" || !regAlarmaSensor.color)))
                                            color = "Rojo";
                                    });
                                    sensor.alarmaActiva = true;
                                    sensor.color = color;
                                    if (nodo.regAlarmas.length>0)
                                        color = "Rojo";
                                    nodo.alarmaActiva = true;
                                    if (!nodo.color || (nodo.color == 'Amarillo' && color == "Rojo" ))
                                        nodo.color = color;
                                    ubicacion.alarmaActiva = true;
                                    if (!ubicacion.color || (ubicacion.color == 'Amarillo' && color == "Rojo"))
                                        ubicacion.color = color;
                                    sucursal.alarmaActiva = true;
                                    if (!sucursal.color || (sucursal.color == 'Amarillo' && color == "Rojo"))
                                        sucursal.color = color;
                                }

                                this.inicializarSensor(sensor, nodo);
                            }

                        }
                    }
                }
                setTimeout(()=>this.checkSlideActiva(),500);
            });

    }

    cambiarSlide(idSlide) {
        let goTo = 0;
        $('.carousel-inner .item').each(function (index) {
            if ($(this).attr('id') == idSlide) {
                goTo = index;
                return false;
            }
        });

        $('#carousel').carousel(goTo);
        window.scrollTo(0, 0);
    }

    /*
     Evitar que deje de existir una slide activa
     */
    checkSlideActiva() {
        let bandera = true;
        $('.carousel-inner .item').each(function (index) {
            if ($(this).hasClass("active")) {
                bandera = false;
            }
        });
        if (bandera) {
            $('#principalSucursales').addClass("active");
        }


    }

    inicializarSensor(sensor, nodo) {
        //Inicializar sensores
        let chartActual;
        setTimeout(function () {
            chartActual = new Highcharts.chart(sensor._id, {
                chart: {
                    type: 'solidgauge',
                    backgroundColor: 'rgba(0,0,0,0)',
                    width: '120',
                    height: '100',
                },
                exporting: {
                    enabled: false
                },
                title: null,
                pane: {
                    center: ['50%', '85%'],
                    size: '130%',
                    startAngle: -90,
                    endAngle: 90,
                    background: {
                        backgroundColor: '#717579',
                        innerRadius: '98%',
                        outerRadius: '100%',
                        shape: 'arc',
                        borderWidth: 0,
                        borderColor: 'transparent'
                    }
                },
                tooltip: {
                    enabled: false
                },
                yAxis: {
                    showFirstLabel: false,
                    showLastLabel: false,
                    min: sensor.tipo_id.rangoDesde,
                    max: sensor.tipo_id.rangoHasta,
                    stops: [
                        [0, !sensor.alarmaActiva ? '#84B547' : ((!sensor.color || sensor.color== 'Rojo') ? '#CC3E4A' : '#fbd749')],
                    ],
                    lineWidth: 0,
                    tickWidth: 0,
                    minorTickInterval: null,
                    tickAmount: 2,
                },
                plotOptions: {
                    solidgauge: {
                        innerRadius: '93%',
                        dataLabels: {
                            y: 5,
                            borderWidth: 0,
                            useHTML: true
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                series: [{
                    name: sensor.etiqueta,
                    data: [sensor.lastMediciones[sensor.lastMediciones.length - 1]],
                    dataLabels: {
                        format: '<div style="text-align:center"><span style="font-size:21px;font-family:Raleway 2;padding-bottom:10px;color: ' +
                        ('#717579') + '">{y}' + " " + sensor.tipo_id.tipo + '</span>'
                    },
                }]
            })

            ChartGlobal.push({_id: sensor._id, chart: chartActual});

        }, 1000);
        sensor.fechaUltimaMedicion = nodo.lastMedicionDate;
        //Establecer socket sensor
        this.socketSensor.on(sensor._id, function (data: any) {
            var point;
            //Busco la serie que corresponda
            //var chartRpm = $('#'+sensor._id).highcharts();
            //var chartRpm = ChartGlobal.chart(sensor._id);
            var chartRpm = null;
            for (let chart of ChartGlobal) {
                if (chart._id == sensor._id) {
                    chartRpm = chart;
                    break;
                }
            }
            if (chartRpm) {
                point = chartRpm.chart.series[0].points[0];
                point.update(data.valor);

            }
            if (this.sucursales != undefined && this.sucursales.length > 0)
                for (let sucursal of this.sucursales) {
                    for (let ubicacion of sucursal.ubicaciones) {
                        for (let nodo of ubicacion.nodos) {
                            for (let s of nodo.sensores_id) {
                                if (s._id == sensor._id) {
                                    s.fechaUltimaMedicion = data.fecha;
                                    break;
                                }
                            }
                        }
                    }
                }

        }.bind(this))
    }

    inicializarSocketAlarma() {
        //Inicilizo socket para alarmas
        this.socket.on("alarma", function (alarma: any) {
            this.recargar();
        }.bind(this));
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/home/home.component.ts